import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white dark:bg-dark-sidebar border-t border-gray-200 dark:border-dark-border px-6 py-4">
      <div className="flex items-center justify-between text-sm text-gray-500 dark:text-dark-text-secondary">
        <div className="flex items-center space-x-4">
          <span>© 2025 PromptHub. All rights reserved.</span>
          <Link 
            to="/privacy" 
            className="hover:text-gray-700 dark:hover:text-dark-text-primary transition-colors"
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms" 
            className="hover:text-gray-700 dark:hover:text-dark-text-primary transition-colors"
          >
            Terms of Service
          </Link>
        </div>
        
        <div className="flex items-center space-x-4">
          <span>Version 1.0.0</span>
          <Link 
            to="/support" 
            className="hover:text-gray-700 dark:hover:text-dark-text-primary transition-colors"
          >
            Support
          </Link>
        </div>
      </div>
    </footer>
  );
};